import { cbApplyType, cbApplyType2 } from '@/dataset/qcrb.js';

const Qcrb = {
  data() {
    return {};
  },
  methods: {
  },
  filters: {
    /**
     * 格式化申请方式
     *
     * @author Cong Peijun <congpeijun@jiemo.net>
     * @param  {String} value
     * @return {String}
     */
    filterApplyType(value) {
      if (!value) {
        return '';
      }
      let types = {};
      cbApplyType.forEach((item) => {
        types[item.value] = item.label;
      });
      return value.split(',').map((item) => {
        return types[item];
      }).join(' ');
    },
    filterExamType(value) {
      if (!value) {
        return '';
      }
      let types = {};
      cbApplyType2.forEach((item) => {
        types[item.value] = item.label;
      });
      return value.split(',').map((item) => {
        return types[item];
      }).join(' ');
    }
  },
};
export default Qcrb;
